/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getKnowledgeFaqDetail, knowledgeUpdateClick } from '@/api';
export default {
  name: 'FAQDetail',
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  components: {},
  data: function data() {
    return {
      info: {}
    };
  },
  computed: {},
  methods: {
    zan: function zan() {
      var _this = this;
      this.$set(this.info, 'is_like', 1);
      knowledgeUpdateClick({
        knowledgeId: this.id,
        state: 1
      }).then(function (res) {
        if (res.success) {
          _this.refresh();
        }
      });
    },
    cai: function cai() {
      var _this2 = this;
      this.$set(this.info, 'is_like', 0);
      knowledgeUpdateClick({
        knowledgeId: this.id,
        state: 0
      }).then(function (res) {
        if (res.success) {
          _this2.refresh();
        }
      });
    },
    refresh: function refresh() {
      var _this3 = this;
      getKnowledgeFaqDetail({
        id: this.id
      }).then(function (res) {
        if (res.success) {
          _this3.info = res.data;
        }
      });
    }
  },
  created: function created() {
    this.refresh();
  }
};